module.exports = __webpack_public_path__ + "img/電気回路_6_10_4.af2b95a9.png";